import { render } from "./BlogCard.vue?vue&type=template&id=525e2139"
import script from "./BlogCard.vue?vue&type=script&lang=js"
export * from "./BlogCard.vue?vue&type=script&lang=js"

import "./BlogCard.vue?vue&type=style&index=0&id=525e2139&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__